import React from 'react';
import Spinner from 'mComponents/Spinner';

export default props => <Spinner {...props} />;
